export const apiDomain = import.meta.env.VITE_APP_API_URL;
